<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
      <div v-if="entity.id" :class="[ tab === 'party' ? 'active' : '' ]" @click="tab = 'party'">Party Groups</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(false)">{{ saveOrUpdate }}</div>
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(true)">{{ saveOrUpdate }} &amp; exit</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">
        Options
        <span class="caret"></span>
      </button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'"></i>
          </a>
        </li>
        <li v-if="entity.id" @click="tab = 'party'">
          <a href="#">
            Party Groups
            <i class="fa fa-check-square-o" v-if="tab === 'party'"></i>
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(false)"><a href="#">{{ saveOrUpdate }}</a></li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(true)"><a href="#">{{ saveOrUpdate }} &amp; exit</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <div v-if="entity.id">
          <user-group-to-party-group
            :user-group-id="entity.id"
            v-show="tab === 'party'"
          />
        </div>
        <div v-if="tab === 'main'">
          <div class="col-xs-12 col-sm-6 main-location-details left top-small">
            <div class="form-group">
              <label for="ext-name" class="form-label">Name *</label>
              <input type="text" class="form-control" id="role-name" v-model="entity.name"/>
            </div>
            <div class="form-group">
              <label for="ext-code" class="form-label">Code</label>
              <input type="text" class="form-control" id="role-code" v-model="entity.code"/>
            </div>
            <div class="form-group">
              <label for="is-p" class="form-label">Is Parent?</label>
              <div class="material-switch">
                <input id="is-p" type="checkbox" v-model="entity.isParent"/>
                <label for="is-p" class="label-success"></label>
              </div>
            </div>
            <div class="form-group">
              <label for="pg" class="form-label">Parent group</label>
              <select class="form-control" id="pg" v-model="entity.parentGroup">
                <option value=""></option>
                <option v-for="(opt, i) in groups" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
            <div class="form-group">
              <label for="acc-code" class="form-label">Access Codes</label>
              <input type="text" class="form-control" id="acc-code" v-model="entity.accessCodes"/>
            </div>
            <div class="form-group">
              <label for="def-cntry" class="form-label">Default Country</label>
              <select class="form-control" id="def-cntry" v-model="entity.defaultCountry">
                <option value=""></option>
                <option v-for="(opt, i) in countries" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="def-cry" class="form-label">Default Currency</label>
              <select class="form-control" id="def-cry" v-model="entity.defaultCurrency">
                <option value=""></option>
                <option v-for="(opt, i) in currencies" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="tnt-code" class="form-label">Tenant</label>
              <input type="text" class="form-control" id="tnt-code" v-model="entity.tenant"/>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import HelperMixin from '../../mixins/Helpers'
  import UserGroupToPartyGroup from './UserGroupToPartyGroup'
  export default {
    name: 'UserGroup',
    mixins: [AdminEntityMixin, HelperMixin],
    components: {UserGroupToPartyGroup},
    data () {
      return {
        shouldUpdateCache: true,
        cachePropertyName: 'userGroups',
        transformForUpdate: {
          tenant: this.toMinus,
          parentGroup: this.toMinus,
          defaultCountry: this.toMinus,
          defaultCurrency: this.toMinus
        },
        newEntityScreen: 'Admin - User Groups',
        editEntityScreen: 'Admin - Edit/View User Group',
        tab: 'main',
        entity: {
          id: null,
          tenant: null,
          code: null,
          name: null,
          parentGroup: null,
          isParent: null,
          accessCodes: null,
          defaultCountry: null,
          defaultCurrency: null
        },
        entityName: 'user-group',
        boxes: [
          {
            prop: 'parentGroup',
            id: 'id'
          },
          {
            prop: 'defaultCurrency',
            id: 'id'
          },
          {
            prop: 'defaultCountry',
            id: 'id'
          }
        ]
      }
    },
    computed: {
      isValid () {
        return this.entity.name && this.entity.name.trim().length
      },
      groups () {
        return this.$store.getters['systemOption/userGroups'].filter(({isParent}) => isParent)
      }
    },
    methods: {
      getBaseData () {
        return {
          id: null,
          tenant: null,
          code: null,
          name: null,
          parentGroup: null,
          isParent: null,
          accessCodes: null,
          defaultCountry: null,
          defaultCurrency: null
        }
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// UserGroup.vue?314bb8a6